// extracted by mini-css-extract-plugin
export default {"base":"vp_CLXXj","text":"vp_c8enO"};